import React, { useState, useEffect } from 'react';
import FormatDetail from './formatDetail';
import { apiFetch } from './api';

const Formate = () => {
  const [items, setItems] = useState([]);
  const [neu, setNeu] = useState(false);
  const [bearbeiten, setBearbeiten] = useState(null);
  const [aktiv, setAktiv] = useState(null);
  const [name, setName] = useState('');
  const [beschreibung, setBeschreibung] = useState('');
  const [loading, setLoading] = useState(true);

  const lade = async () => {
    const res = await apiFetch('/formate');
    const data = await res.json();
    setItems(data);
    setLoading(false);
  };

  useEffect(() => { lade(); }, []);

  const erstellen = async () => {
    if (!name) return;
    await apiFetch('/formate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, beschreibung })
    });
    setName(''); setBeschreibung(''); setNeu(false);
    lade();
  };

  const speichern = async () => {
    if (!name) return;
    await apiFetch(`/formate/${bearbeiten.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, beschreibung, notizen: bearbeiten.notizen, status: bearbeiten.status, farbe: bearbeiten.farbe })
    });
    setName(''); setBeschreibung(''); setBearbeiten(null);
    lade();
  };

  const loeschen = async (id) => {
    await apiFetch(`/formate/${id}`, { method: 'DELETE' });
    lade();
  };

  const bearbeitenOeffnen = (item) => {
    setBearbeiten(item);
    setName(item.name);
    setBeschreibung(item.beschreibung || '');
    setNeu(false);
  };

  const schliessen = () => { setNeu(false); setBearbeiten(null); setName(''); setBeschreibung(''); };
  const zeigeForm = neu || bearbeiten;

  if (aktiv) {
    return <FormatDetail itemId={aktiv} onZurueck={() => { setAktiv(null); lade(); }} />;
  }

  const inputStyle = {
    width: '100%', padding: '10px 14px', fontSize: '14px',
    border: '1px solid #e8e8e8', borderRadius: '8px', outline: 'none', boxSizing: 'border-box'
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: '500', color: '#6b6b6b',
    marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px'
  };

  const statusBadge = (status) => {
    const farben = {
      idee: { bg: '#f3e5f5', text: '#7b1fa2' },
      pitch: { bg: '#e3f2fd', text: '#1565c0' },
      'in entwicklung': { bg: '#fff3e0', text: '#e65100' },
      abgeschlossen: { bg: '#f0f0ee', text: '#6b6b6b' }
    };
    const f = farben[status] || farben.idee;
    return (
      <span style={{
        fontSize: '11px', fontWeight: '500', color: f.text, backgroundColor: f.bg,
        padding: '3px 10px', borderRadius: '12px', textTransform: 'capitalize'
      }}>{status}</span>
    );
  };

  return (
    <div style={{ padding: '40px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '32px' }}>
        <div>
          <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 6px 0', letterSpacing: '-0.5px' }}>
            Formatentwicklung
          </h2>
          <p style={{ fontSize: '14px', color: '#9b9b9b', margin: 0 }}>
            {items.length} {items.length === 1 ? 'Format' : 'Formate'}
          </p>
        </div>
        <button onClick={() => { schliessen(); setNeu(true); }} style={{
          padding: '8px 16px', backgroundColor: '#1a1a1a', color: '#ffffff', border: 'none',
          borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
        }}>+ Neues Format</button>
      </div>

      {zeigeForm && (
        <div style={{ backgroundColor: '#ffffff', border: '1px solid #efefef', borderRadius: '10px', padding: '24px', marginBottom: '16px' }}>
          <h3 style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 16px 0' }}>
            {bearbeiten ? 'Format bearbeiten' : 'Neues Format'}
          </h3>
          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Name</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="z.B. Neues Talk-Format" style={inputStyle} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={labelStyle}>Beschreibung</label>
            <input type="text" value={beschreibung} onChange={(e) => setBeschreibung(e.target.value)} placeholder="Kurze Beschreibung" style={inputStyle} />
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={bearbeiten ? speichern : erstellen} style={{
              padding: '8px 20px', backgroundColor: '#1a1a1a', color: '#ffffff', border: 'none',
              borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
            }}>{bearbeiten ? 'Speichern' : 'Erstellen'}</button>
            <button onClick={schliessen} style={{
              padding: '8px 20px', backgroundColor: 'transparent', color: '#6b6b6b',
              border: '1px solid #e8e8e8', borderRadius: '8px', fontSize: '13px', cursor: 'pointer'
            }}>Abbrechen</button>
          </div>
        </div>
      )}

      {loading ? (
        <p style={{ color: '#9b9b9b', fontSize: '14px' }}>Lädt...</p>
      ) : items.length === 0 ? (
        <div style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '60px 40px', border: '1px solid #efefef', textAlign: 'center' }}>
          <p style={{ color: '#9b9b9b', fontSize: '14px', margin: 0 }}>Noch keine Formate. Erstelle dein erstes!</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {items.map((item) => (
            <div key={item.id} onClick={() => setAktiv(item.id)} style={{
              backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #efefef',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              cursor: 'pointer', overflow: 'hidden', position: 'relative'
            }}>
              {item.farbe && (
                <div style={{
                  position: 'absolute', left: 0, top: 0, bottom: 0,
                  width: '4px', backgroundColor: item.farbe, flexShrink: 0
                }} />
              )}
              <div style={{
                display: 'flex', alignItems: 'center', gap: '14px',
                padding: '20px 24px', paddingLeft: item.farbe ? '28px' : '24px', flex: 1
              }}>
                <div>
                  <p style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 4px 0' }}>{item.name}</p>
                  {item.beschreibung && <p style={{ fontSize: '13px', color: '#9b9b9b', margin: 0 }}>{item.beschreibung}</p>}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '20px 24px' }}>
                {statusBadge(item.status)}
                <button onClick={(e) => { e.stopPropagation(); bearbeitenOeffnen(item); }} style={{
                  padding: '4px 10px', backgroundColor: 'transparent', border: '1px solid #e8e8e8',
                  borderRadius: '6px', fontSize: '11px', color: '#6b6b6b', cursor: 'pointer'
                }}>Bearbeiten</button>
                <button onClick={(e) => { e.stopPropagation(); loeschen(item.id); }} style={{
                  padding: '4px 10px', backgroundColor: 'transparent', border: '1px solid #ffdddd',
                  borderRadius: '6px', fontSize: '11px', color: '#cc0000', cursor: 'pointer'
                }}>Löschen</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Formate;